<template>
  <div class="dev-tips-filters bg-white p-4 rounded-lg shadow-sm border">
    <div class="flex flex-col lg:flex-row gap-4">
      <!-- Search Input -->
      <div class="flex-1">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Search Tips
        </label>
        <div class="relative">
          <i class="pi pi-search absolute left-3 top-1/2 transform -translate-y-1/2
            text-gray-400"></i>
          <InputText
            v-model="localFilters.search"
            placeholder="Search in title and content..."
            class="w-full pl-10"
            @input="handleFilterChange"
          />
        </div>
      </div>

      <!-- Dimension Filter -->
      <div class="w-full lg:w-48">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Dimension
        </label>
        <Dropdown
          v-model="localFilters.dimensionValue"
          :options="dimensionOptions"
          option-label="label"
          option-value="value"
          placeholder="All Dimensions"
          class="w-full"
          @change="handleFilterChange"
        />
      </div>

      <!-- Status Filter -->
      <div class="w-full lg:w-48">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Status
        </label>
        <Dropdown
          v-model="localFilters.active"
          :options="statusOptions"
          option-label="label"
          option-value="value"
          placeholder="All Status"
          class="w-full"
          @change="handleFilterChange"
        />
      </div>

      <!-- Dimension Status Filter -->
      <div class="w-full lg:w-48">
        <label class="block text-sm font-medium text-gray-700 mb-2">
          Dimension Status
        </label>
        <Dropdown
          v-model="localFilters.dimensionStatus"
          :options="dimensionStatusOptions"
          option-label="label"
          option-value="value"
          placeholder="All Dimension Status"
          class="w-full"
          @change="handleFilterChange"
        />
      </div>

      <!-- Clear Filters Button -->
      <div class="flex items-end">
        <Button
          label="Clear Filters"
          icon="pi pi-times"
          class="p-button-text p-button-sm"
          @click="handleClearFilters"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';
import Button from 'primevue/button';

export default {
  name: 'DevTipsFilters',
  components: {
    InputText,
    Dropdown,
    Button,
  },
  props: {
    filters: {
      type: Object,
      required: true,
      default: () => ({
        dimensionValue: '',
        active: null,
        search: '',
        dimensionStatus: '',
      }),
    },
  },
  data() {
    return {
      localFilters: {
        dimensionValue: '',
        active: null,
        search: '',
        dimensionStatus: '',
      },
      statusOptions: [
        { label: 'All Status', value: null },
        { label: 'Active', value: true },
        { label: 'Inactive', value: false },
      ],
      dimensionStatusOptions: [
        { label: 'All Dimension Status', value: '' },
        { label: 'Valid Dimensions', value: 'valid' },
        { label: 'Invalid Dimensions', value: 'invalid' },
        { label: 'No Dimensions', value: 'none' },
      ],
    };
  },
  computed: {
    ...mapGetters('dimensions', ['getAllDimensions']),

    dimensionOptions() {
      const dimensions = this.getAllDimensions;
      const options = [{ label: 'All Dimensions', value: '' }];

      if (dimensions && dimensions.length > 0) {
        dimensions.forEach((dimension) => {
          options.push({
            label: dimension.translation?.en || dimension.value,
            value: dimension.value,
          });
        });
      }

      return options;
    },
  },
  watch: {
    filters: {
      handler(newFilters) {
        this.localFilters = { ...newFilters };
      },
      immediate: true,
      deep: true,
    },
  },
  async mounted() {
    // Load dimensions if not already loaded
    if (this.getAllDimensions.length === 0) {
      await this.$store.dispatch('dimensions/fetchDimensions');
    }
  },
  methods: {
    ...mapActions('dimensions', ['fetchDimensions']),

    handleFilterChange() {
      this.$emit('update-filters', { ...this.localFilters });
    },

    handleClearFilters() {
      this.localFilters = {
        dimensionValue: '',
        active: null,
        search: '',
        dimensionStatus: '',
      };
      this.$emit('clear-filters');
    },
  },
};
</script>

<style scoped>
.dev-tips-filters {
  min-height: 80px;
}
</style>
